import { tryPromise } from "../cutil/LangUtil";
export class Polling {
    constructor(spaceTime) {
        this.spaceTime = spaceTime;
        this.stop = false;
    }
    /**
     * 开始执行
     * @param task
     * @param update
     */
    startPolling(task, updateClosure) {
        this.stop = false;
        const execute = async () => {
            task.dirty();
            const result = await tryPromise(task.get());
            // 这个时候已经停止了，那么结果也不需要更新出去
            if (this.stop) {
                console.log("data response, user stop");
                return;
            }
            this.timer = setTimeout(() => {
                execute();
            }, this.spaceTime);
            updateClosure(result);
        };
        execute();
    }
    /**
     * 停止执行
     */
    stopPolling() {
        this.stop = true;
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
